<template>
  <div class="tabs-wrapper">
    <el-scrollbar class="tabs-scroll">
      <Tabs
        :model-value="String(activeTab)"
        @update:model-value="onModelUpdate"
      >
        <TabsList>
          <TabsTrigger
            v-for="(tab, key) in tabs"
            :key="key"
            :value="String(key)"
            :class="{ 'tab-trigger--disabled': tab.disabled }"
            :aria-disabled="tab.disabled ? 'true' : 'false'"
            :title="tab.disabled ? tab.disabledReason : undefined"
          >
            <svg-icon
              v-if="tab.icon"
              :name="tab.icon"
              class="w-4 h-4 shrink-0"
            />
            <div>{{ tab.label }}</div>
            <svg-icon
              v-if="tab.disabled"
              name="huge-unlock"
              class="w-3 h-3 ml-1 opacity-50 tab-trigger__lock"
            />
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </el-scrollbar>

    <div class="action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
import { Tabs, TabsList, TabsTrigger } from "@/shared/ui/tabs";

export default {
  name: "BaseTabs",
  components: { Tabs, TabsList, TabsTrigger },
  props: {
    tabs: { type: Object, required: true },
    activeTab: { required: true },
  },
  emits: ["change:tab"],
  data() {
    return {
      lastEmittedValue: null,
      lastEmittedTime: 0,
    };
  },
  methods: {
    onModelUpdate(value) {
      const now = Date.now();
      if (value === this.lastEmittedValue && now - this.lastEmittedTime < 300) {
        return;
      }
      this.lastEmittedValue = value;
      this.lastEmittedTime = now;
      this.$emit("change:tab", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-wrapper {
  @apply flex w-full items-center justify-between gap-3;
}

.tabs-scroll {
  min-width: 0;
  flex: 1;
}

.tabs-scroll :deep(.el-scrollbar__bar.is-horizontal) {
  display: none;
}

.action {
  @apply flex-shrink-0;
}

.tab-trigger--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tab-trigger--disabled :deep(*) {
  pointer-events: none;
}

.tab-trigger__lock {
  pointer-events: none;
}
</style>
